import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { useNotificationStore, NotificationType } from '../../stores/useNotificationStore';
import { FiCheckCircle, FiXCircle, FiAlertTriangle, FiInfo } from '../../utils/icons';

const ICONS: Record<NotificationType, React.FC<{ size?: number }>> = {
  success: FiCheckCircle,
  error: FiXCircle,
  warning: FiAlertTriangle,
  info: FiInfo,
};

// Estilo "solid": fundo na cor cheia do tipo, texto claro por cima — em vez de
// fundo claro + borda de destaque. Cores vêm dos tokens do tema (claro/escuro).
const VAR_BY_TYPE: Record<NotificationType, string> = {
  success: 'var(--cp-success)',
  error: 'var(--cp-danger)',
  warning: 'var(--cp-warning)',
  info: 'var(--cp-info)',
};

// Aviso: fundo âmbar já é claro em ambos os temas, então o texto fica escuro
// para manter contraste; os demais tipos usam texto claro.
const FG_BY_TYPE: Record<NotificationType, string> = {
  success: '#ffffff',
  error: '#ffffff',
  warning: '#1a1206',
  info: '#ffffff',
};

const AUTO_DISMISS_MS = 4500;

const NotificationCenter: React.FC = () => {
  const items = useNotificationStore(s => s.items);
  const dismiss = useNotificationStore(s => s.dismiss);

  if (items.length === 0) return null;

  return (
    <ToastContainer
      className="p-3"
      style={{ position: 'fixed', top: 0, right: 0, zIndex: 2000 }}
    >
      {items.map(item => {
        const Icon = ICONS[item.type];
        const bg = VAR_BY_TYPE[item.type];
        const fg = FG_BY_TYPE[item.type];
        return (
          <Toast
            key={item.id}
            onClose={() => dismiss(item.id)}
            delay={AUTO_DISMISS_MS}
            autohide
            style={{
              background: bg,
              color: fg,
              border: 'none',
              borderRadius: 10,
              boxShadow: '0 10px 28px rgba(0, 0, 0, 0.28)',
              minWidth: 320,
              maxWidth: 400,
            }}
          >
            <Toast.Body className="d-flex align-items-start gap-2 py-3">
              <Icon size={18} />
              <span style={{ fontWeight: 500, fontSize: '0.9rem', flexGrow: 1, lineHeight: 1.4 }}>
                {item.message}
              </span>
              <button
                type="button"
                onClick={() => dismiss(item.id)}
                aria-label="Fechar"
                style={{
                  background: 'none', border: 'none', color: fg, opacity: 0.7,
                  fontSize: '1.1rem', lineHeight: 1, cursor: 'pointer', padding: 0, flexShrink: 0,
                }}
              >
                ×
              </button>
            </Toast.Body>
          </Toast>
        );
      })}
    </ToastContainer>
  );
};

export default NotificationCenter;
